import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueRouter from 'vue-router'
import router from './router'
import ElementUI from 'element-ui'

import echarts from 'echarts'
import world from '../node_modules/echarts/map/json/world.json'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.prototype.axios = axios;
Vue.prototype.$echarts = echarts;
echarts.registerMap('world',world);

new Vue({
  el:'#app',
  render: h => h(App),
  router: router,
  beforeCreate(){
    Vue.prototype.$bus = this;
  }
}).$mount('#app')
